"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKETING_CONTACTS_QUANTITIES = void 0;
var MARKETING_CONTACTS_QUANTITIES = {
  'additional-marketing-contacts-starter': 1000,
  'additional-marketing-contacts-pro': 5000,
  'additional-marketing-contacts-enterprise': 10000
};
exports.MARKETING_CONTACTS_QUANTITIES = MARKETING_CONTACTS_QUANTITIES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ParcelQuantityMap.js
// module id = 425
// module chunks = 5 6 7